module.exports = __webpack_public_path__ + "img/bb.f8c67af1.png";